export function saveToLocalStorage(recName, data) {
	localStorage.setItem(recName, JSON.stringify(data))
}
